/* eslint-disable */
import React, {useEffect, useState} from 'react';
import AppModal from '../../components/common/AppModal';
import Container from '@mui/material/Container';
import './header.scss';
import Spacer from '../../components/Agent/Spacer';
/* The brand mark, vectorised.
 *
 * This was HevolveLogo.png, and at the 26-32px a header gives it the PNG
 * resolved to an indistinct smudge: it is the same artwork as the mark on
 * /docs/widget, but drawn with hairline strokes inside roughly 15% of dead
 * canvas margin on every side, so the strokes land under one device pixel.
 *
 * hevolve-mark.svg is built from HARTOS's Illustrator master
 * (nixos/branding/hart-logo.svg) with the viewBox retargeted from the artboard
 * to the drawing's own bounding box, which is what recovers that lost 15%, and
 * with width/height attributes dropped so CSS decides the size.
 *
 * The other candidate was src/data/logo.gif, which /docs/widget uses and which
 * reads best of the three because its hourglass is filled rather than outlined.
 * It is 3.2 MB, animated, and was being loaded twice on that page.
 */
import logo_dark from '../../assets/images/hevolve-mark.svg';

import Snackbar from '@mui/material/Snackbar';
import {SnackbarContent} from '@mui/material';
import { SEND_EMAIL_URL } from '../../config/apiBase';
import { logger } from '../../utils/logger';

const Header = ({fixed}) => {
  const [modal, toggleModal] = useState(false);
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  logger.log(hamburgerOpen);

  const [open, setOpen] = React.useState(false);

  function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }

  function sendUserInfo(event) {
    event.preventDefault();
    logger.log('Posting Email to hertz API...');
    var userName = document.getElementById('name').value;
    var email = document.getElementById('email').value;
    var phoneNumber = document.getElementById('phoneNumber').value;
    var company = document.getElementById('company').value;
    var question = document.getElementById('comments').value;
    var userDetails = {
      userName: userName,
      email: email,
      phoneNumber: phoneNumber,
      company: company,
      question: question,
    };
    logger.log('Sending User details ->> ' + JSON.stringify(userDetails));
    fetch(SEND_EMAIL_URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userDetails),
    })
      .then((response) => response.json())
      .then((data) => {
        logger.log('Success:', data);
        toggleModal();
        //   handleClose();
        setOpen(true);
        // setSnackPack((prev) => [...prev, { 'Thanks for submission !', key: new Date().getTime() }]);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  useEffect(() => {
    const dropdowns = document.querySelectorAll('.navbar-nav .dropdown');

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('mouseenter', (event) => {
        if ('ontouchstart' in window || navigator.maxTouchPoints) return;
        dropdowns.forEach((dropdown) => {
          dropdown.classList.remove('open');
        });
        event.currentTarget.classList.add('open');
      });

      dropdown.addEventListener('mouseleave', (event) => {
        if ('ontouchstart' in window || navigator.maxTouchPoints) return;
        event.currentTarget.classList.remove('open');
      });

      dropdown.addEventListener('click', (event) => {
        event.stopPropagation();
        dropdowns.forEach((dropdown) => {
          if (dropdown !== event.currentTarget) {
            dropdown.classList.remove('open');
          }
        });
        event.currentTarget.classList.toggle('open');
      });
    });
    document.addEventListener('click', () => {
      dropdowns.forEach((dropdown) => {
        dropdown.classList.remove('open');
      });
    });

    // Only the padding changes on scroll. The colour does not.
    //
    // This used to paint the bar WHITE inline -- #ffffffdd past 80px and
    // rgba(255,255,255,0.7) above it -- which is a leftover from when this
    // header sat on a light page. The site is dark and the nav links are
    // #FFFAE8, so the moment anyone scrolled, the bar became near-white under
    // near-white text: rgba(255,255,255,0.7) over the bar's rgb(33,42,49)
    // composites to rgb(188,191,193), which measures 1.77:1.
    //
    // The `else` branch made it worse than a scrolled-state bug: it fires at
    // scrollTop 0 too, so scrolling down a few pixels and back left the bar
    // light permanently, on every page using this header.
    //
    // Found by the contrast audit, which reported rgb(188,191,193) three times
    // before this was believed -- twice dismissed as a compositor artefact
    // because the bar measures rgb(33,42,49) until a scroll event fires.
    // Colour belongs in the stylesheet, where .navbar-fixed already lives.
    document.addEventListener('scroll', () => {
      if (
        document.body.scrollTop > 80 ||
        document.documentElement.scrollTop > 80
      ) {
        if (document.getElementById('navbar') != null) {
          document.getElementById('navbar').style.padding = '0px 0px';
        }
      } else if (document.getElementById('navbar') != null) {
        // Restores the resting padding. Dropping this branch entirely would
        // have left the bar collapsed to 0 forever after one scroll.
        document.getElementById('navbar').style.padding = '10px 5px';
      }
    });
  }, []);

  return (
    <header>
      <AppModal isOpen={modal} toggle={toggleModal} title={<><h5 id="exampleModalLongTitle">Get in touch</h5></>}>

          <div className="custom-form">
            <div id="message"></div>
            <form
              // method="post"
              // action="php/contact.php"
              name="contact-form"
              id="contact-form"
              onSubmit={sendUserInfo}
            >
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group mb-4">
                    <input
                      name="name"
                      id="name"
                      type="text"
                      className="form-control"
                      placeholder="Your Name..."
                    />
                  </div>
                  <div className="form-group mb-4">
                    <input
                      name="email"
                      id="email"
                      type="email"
                      className="form-control"
                      placeholder="Your Email..."
                    />
                  </div>
                  <div className="form-group mb-4">
                    <input
                      name="phoneNumber"
                      id="phoneNumber"
                      type="number"
                      className="form-control"
                      placeholder="Your Phone Number..."
                    />
                  </div>
                  <div className="form-group mb-4">
                    <input
                      name="company"
                      id="company"
                      type="text"
                      className="form-control"
                      placeholder="Your Company..."
                    />
                  </div>
                  <div className="form-group">
                    <textarea
                      name="comments"
                      id="comments"
                      rows="4"
                      className="form-control"
                      placeholder="Your Message..."
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-sm-12 text-right">
                  <input
                    type="submit"
                    id="submit"
                    name="send"
                    className="submitBnt btn btn-custom"
                    value="Send Message"
                  />
                  <div id="simple-msg"></div>
                </div>
              </div>
            </form>
          </div>
        
      </AppModal>

      {fixed && <Spacer h={67} />}
      <div />
      <div id="navbar" className={`navbar-wrapper ${fixed ? 'navbar-fixed' : ''}`}>
        <Container>
          <div className="navbar">
            <div className="navbar-header" id="navbar-header-id">
              {/* Mark plus wordmark, not the mark alone.
                *
                * A 32px icon on its own resolves to a coloured blob that names
                * nothing; /docs/widget already paired this mark with EVOLVE and
                * that lockup is the one worth keeping. The wordmark is a <span>
                * rather than part of the image so it stays selectable text,
                * scales with the user's font settings, and costs no bytes.
                *
                * href was "/#", which navigates home and then appends an empty
                * fragment. */}
              <a className="navbar-brand" href="/">
                <img
                  src={logo_dark}
                  alt="Hevolve"
                  className="logo-dark"
                />
                <span className="brand-wordmark">EVOLVE</span>
              </a>
              <label htmlFor="navbar-nav-toggle" className="navbar-toggle">
                {hamburgerOpen ? (
                  <span onClick={() => setHamburgerOpen(false)}>X</span>
                ) : (
                  <span onClick={() => setHamburgerOpen(true)}>☰</span>
                )}
              </label>
            </div>
            <div className="navbar-nav-wrapper">
              <input type="checkbox" id="navbar-nav-toggle" />
              <ul className="nav navbar-nav">
                <li>
                  <a href="/">Home</a>
                </li>

                <li className="dropdown">
                  <a>Products</a>
                  <ul className="dropdown-menu">
                    <li>
                      <a href="/agents">Hevolve Agents</a>
                    </li>
                    <li>
                      <a href="/docs">Developer API</a>
                    </li>
                    <li>
                      <a href="/download">Download Nunba</a>
                    </li>
                    <li>
                      <a href="/pupit">Pupit</a>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  <a>Developer Guide</a>
                  <ul className="dropdown-menu">
                    {/* Deep links now that each guide has a URL. These used to
                        point at /products/recap, /pupitdocs and /hevolvedocs,
                        all three of which returned the 404 page. */}
                    <li>
                      <a href="/docs/sdk">Mindstory SDK</a>
                    </li>
                    <li>
                      <a href="/docs/widget">Website widget</a>
                    </li>
                    <li>
                      <a href="/docs/hive">Hive API</a>
                    </li>
                    <li>
                      <a href="/docs/client">Pupit video API</a>
                    </li>
                    <li>
                      <a href="/docs/server">Pupit SDK (server)</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="/agents">Try HevolveAI</a>
                </li>

                {/* Learn — the content surfaces.
                    The site prerenders 263 pages: ~200 research explainers,
                    the answers set, incidents, news, the hive census. Until
                    now the navigation linked exactly one of those families
                    (Blog). Everything else existed only in sitemap.xml, so no
                    reader could arrive at it by following a link and no
                    internal link pointed at it. */}
                <li className="dropdown">
                  <a>Learn</a>
                  <ul className="dropdown-menu">
                    <li>
                      <a href="/blog">Blog</a>
                    </li>
                    <li>
                      <a href="/news">News</a>
                    </li>
                    <li>
                      <a href="/research">Research explained</a>
                    </li>
                    <li>
                      <a href="/answers">Answers</a>
                    </li>
                    <li>
                      <a href="/incidents">Incident write-ups</a>
                    </li>
                    <li>
                      <a href="/hive">Hive census</a>
                    </li>
                    <li>
                      <a href="/listings">Listings</a>
                    </li>
                  </ul>
                </li>
                {/* Company — Events, Privacy, Live Support, Contact and Press
                    were four separate top-level entries. Twelve items did not
                    fit the bar, so the row wrapped onto a second line and the
                    header looked broken at every width above mobile. */}
                <li className="dropdown">
                  <a>Company</a>
                  <ul className="dropdown-menu">
                    <li>
                      <a href="/aboutus">About us</a>
                    </li>
                    <li>
                      <a href="/press">Press kit</a>
                    </li>
                    <li>
                      <a href="https://etime.hertzai.com/event">Events</a>
                    </li>
                    <li>
                      <a href="/contact">Live Support</a>
                    </li>
                    <li>
                      <a href="/contact">Contact Us</a>
                    </li>
                    <li>
                      <a href="/blog/privacy-first-ai">Privacy</a>
                    </li>
                  </ul>
                </li>
                <li className="nav-download-cta">
                  <a
                    href="/download"
                    style={{
                      // #10b981 with white text measures 2.54:1, under the 3:1
                      // floor for text of any size. This is the header's
                      // primary call to action, on every page.
                      //
                      // Darkening the green rather than darkening the text:
                      // emerald-700 keeps a filled green pill reading as the
                      // strongest thing in the bar, where near-black text on
                      // bright mint would read as a secondary chip. White on
                      // #047857 measures 5.3:1, past AA for body text.
                      background: '#047857',
                      color: '#fff',
                      padding: '8px 18px',
                      borderRadius: '999px',
                      fontWeight: 700,
                      whiteSpace: 'nowrap',
                    }}
                    aria-label="Download Nunba, free local-first AI for Windows"
                  >
                    ⬇ Download Nunba
                  </a>
                </li>

                {/* Live Support and Contact Us moved into Company above; both
                    are still one click away, and the bar now fits one line. */}
                <li>
                  <a href="/pricing">Pricing</a>
                </li>
                <li>
                  <a href="/signup">Sign in</a>
                </li>

                {/* <li className="dropdown">
                  <a>Ready To Use Models</a>
                  <ul className="dropdown-menu">
                    <li><a target="_blank" rel="noopener noreferrer" href="https://app.nanonets.com/#/ocr/test/cc3330a2-acf6-4199-ba46-43a70a9ca337">Invoice OCR</a></li>
                    <li><a target="_blank" rel="noopener noreferrer" href="https://app.nanonets.com/#/ocr/test/b56b4782-fdd6-401c-9c91-c8be6b607d40">Passport OCR</a></li>
                    <li><a target="_blank" rel="noopener noreferrer" href="https://app.nanonets.com/#/ocr/test/0dcdfe5b-6336-47da-9186-8ff9868f6c53">Driver's License OCR</a></li>
                    <li><a target="_blank" rel="noopener noreferrer" href="https://app.nanonets.com/#/ic/test/353cea12-4dcc-47ee-b139-dd345157b17d">NSFW Classification</a></li>
                    <li><a target="_blank" rel="noopener noreferrer" href="https://app.nanonets.com/#/OD/test/6c6f8dc2-a7f4-4e1c-94a7-a75beea13cad">Fashion Apparel / Accessories Detection</a></li>
                    <li><a target="_blank" rel="noopener noreferrer" href="https://app.nanonets.com/#/OD/test/c4207fe4-3866-42b7-9b54-50f02730e10b">General Tagging</a></li>
                    <li><a target="_blank" rel="noopener noreferrer" href="https://app.nanonets.com/#/OD/test/4e8d57da-9f06-48fd-bd0a-3d798ab87ccc">Furniture Detection</a></li>
                    <li><a target="_blank" rel="noopener noreferrer" href="https://app.nanonets.com/#/od/test/5b7b2ad1-43f9-47f9-9f27-eb4aedd78663">Face Detection</a></li>
                    <li><a target="_blank" rel="noopener noreferrer" href="https://app.nanonets.com/#/OD/test/2cfab12f-b14c-4220-be31-35a41c57c505">Pedestrian Detection in Aerial Images</a></li>
                  </ul>
                </li> */}

                {/* <li><a href="/#case-studies">Case studies</a></li> */}

                {/* <li><a href="/pricing">Pricing</a></li>

                <li className="dropdown">
                  <a>Resources</a>
                  <ul className="dropdown-menu">
                    <li><a href="https://nanonets.com/blog">Blog</a></li>
                    <li><a href="https://nanonets.com/documentation">Documentation</a></li>
                    <li><a href="https://nanonets.github.io/tutorials-page">Tutorials</a></li>
                    <li><a href="https://nanonets.com/help">Help</a></li>
                  </ul>
                </li> */}

                {/* <li><a id="signup" href="https://app.nanonets.com"><button type="button" className="navbar-btn">Start Building</button></a></li> */}
              </ul>
              <Snackbar
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                open={open}
                autoHideDuration={2000}
                onClose={handleClose}
              >
                <SnackbarContent
                  contentprops={{
                    'aria-describedby': 'message-id',
                  }}
                  // prettier-ignore
                  message={(
                    `Thanks for submission, we will get back to you !`
                  )}
                />
              </Snackbar>
            </div>
          </div>
        </Container>
      </div>
    </header>
  );
};

export default Header;
